import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // Automatically scrolls to top and restores page scrolling if navigating away from call screens
  useEffect(() => {
    window.scrollTo(0, 0);

    const callPages = ["/video-call", "/audio-call", "/go-live", "/private-video-room", "/free-video-call"];
    if (!callPages.includes(pathname)) {
      document.body.style.overflow = "";
      document.body.style.height = "";
      document.body.classList.remove("modal-open");
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;